import { MutationTree, Mutation } from "vuex";
import { ISearchHit, ISearchResult, IState } from "./state";
import { ActionPayload, IToggleFilterPayload } from "./actions";

export interface ShouldFocusPayload {
  shouldFocus: boolean;
  index: number;
}

type MutationHandler<PayloadType> = (
  state: IState,
  payload: ActionPayload<PayloadType>
) => any;

const setStateMutation: MutationHandler<IState> = (state, { payload }) => {
  Object.assign(state, payload);
};
const increasePageMutation: MutationHandler<IState> = (state, { payload }) => {
  Object.assign(state, { currentPage: state.currentPage + 1 });
};
const setPageMutation: MutationHandler<number> = (state, { payload }) => {
  Object.assign(state, { currentPage: payload });
};
const addHitsMutation: MutationHandler<ISearchHit[]> = (state, { payload }) => {
  state.searchResult.searchHits.push(...payload);
};
const setQueryMutation: MutationHandler<string> = (state, { payload }) => {
  state.query = payload;
};
const newSearchMutation: MutationHandler<ISearchResult> = (
  state,
  { payload }
) => {
  state.currentPage = 0;
  state.searchResult = payload;
};
const toggleFilterMutation: MutationHandler<IToggleFilterPayload> = (
  state,
  { payload }
) => {
  const filter = state.templateFilter.find((f) => f.id === payload.id);
  if (filter) {
    filter.selected = payload.value;
  }
};
const deselectAllFiltersMutation: MutationHandler<undefined> = (
  state,
  { payload }
) => {
  state.templateFilter.forEach((f) => (f.selected = false));
};
const shouldFocusMutation: MutationHandler<ShouldFocusPayload> = (
  state,
  { payload }
) => {
  state.focus = payload;
};
const setSearchedQueryMutation: MutationHandler<ShouldFocusPayload> = (
  state,
  { payload }
) => {
  state.searchedQuery = state.query;
};
const setSuggestionMutation: MutationHandler<string> = (state, { payload }) => {
  state.suggestion = payload;
};
const setAmountOfShowingHitsMutation: MutationHandler<number> = (
  state,
  { payload }
) => {
  state.amountOfShowingHits = payload;
};
const setCurrentlyShowingHitsMutation: MutationHandler<any> = (
  state,
  { payload }
) => {
  state.currentlyShowingHits = payload;
};

const mutations: MutationTree<IState> = {
  setState: setStateMutation,
  increasePage: increasePageMutation,
  setPageMutation: setPageMutation,
  addHits: addHitsMutation,
  setQuery: setQueryMutation,
  newSearch: newSearchMutation,
  toggleFilter: toggleFilterMutation,
  deselectAllFilters: deselectAllFiltersMutation,
  shouldFocus: shouldFocusMutation,
  setSearchedQuery: setSearchedQueryMutation,
  setSuggestion: setSuggestionMutation,
  setAmountOfShowingHits: setAmountOfShowingHitsMutation,
  setCurrentlyShowingHits: setCurrentlyShowingHitsMutation,
};

export default mutations;
